import React from 'react';
import { StyledImageLink, StyledImageLinkImage, StyledImageLinkImageOverlay } from './HoverableImageLink.styles.mjs';

const HoverableImageLink = ({ backgroundColor, backgroundHoverColor, imageSrc, imageHoverSrc, href, alt }) => {
    return (React.createElement(StyledImageLink, { backgroundColor: backgroundColor, backgroundHoverColor: backgroundHoverColor, href: href, alt: alt },
        React.createElement(StyledImageLinkImage, { src: imageSrc, alt: alt }),
        React.createElement(StyledImageLinkImageOverlay, { src: imageHoverSrc, alt: alt })));
};

export { HoverableImageLink as default };
//# sourceMappingURL=HoverableImageLink.mjs.map
